const GOLD = '#e05590';

/**
 * Uppercase eyebrow/kicker label used above section headings on the
 * "informational" pages (dla-firm, dostawa, pogrzeb, slub, kontakt,
 * warsztaty-florystyczne, zamowienie-specjalne) — previously each page
 * redefined an identical local `Tag`/`SectionLabel` component.
 */
export function SectionLabel({ text }: { text: string }) {
  return (
    <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: 9.5, letterSpacing: '0.32em', textTransform: 'uppercase', color: GOLD, margin: '0 0 14px' }}>
      {text}
    </p>
  );
}
